import { ColorPicker, Flex, Tooltip, Typography } from 'antd'
import { cx } from 'antd-style'
import { useTranslation } from 'react-i18next'

import { AVATAR_PALETTE } from 'src/components/UserCell/avatarColor'

import { useStyles } from './styles'

const PRESET_COLORS = [...new Set<string>(AVATAR_PALETTE)]

const COLOR_NAME_KEYS: Record<string, string> = {
  '#0f766e': 'teal',
  '#2563eb': 'blue',
  '#4f46e5': 'indigo',
  '#7c3aed': 'violet',
  '#c026d3': 'fuchsia',
  '#db2777': 'pink',
  '#dc2626': 'red',
  '#b45309': 'amber',
  '#059669': 'emerald',
  '#0891b2': 'cyan',
  '#475569': 'slate',
  '#0e7490': 'deepCyan',
  '#9333ea': 'purple'
}

type IconPickerColorFieldProps = {
  value: string
  onChange: (color: string) => void
}

export const IconPickerColorField = ({
  value,
  onChange
}: IconPickerColorFieldProps) => {
  const { styles } = useStyles()
  const { t } = useTranslation()

  const describe = (color: string) => {
    const key = COLOR_NAME_KEYS[color.toLowerCase()]
    const name = key ? t(`iconPicker.colors.${key}`) : ''

    return name ? `${name} (${color})` : color
  }

  return (
    <Flex align="center" gap={8} wrap>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t('iconPicker.background')}
      </Typography.Text>

      {PRESET_COLORS.map((color) => {
        const selected = color.toLowerCase() === value.toLowerCase()
        const label = describe(color)

        return (
          <Tooltip key={color} title={label}>
            <button
              type="button"
              aria-label={label}
              aria-pressed={selected}
              className={cx(styles.swatch, selected && styles.swatchSelected)}
              style={{ background: color }}
              onClick={() => onChange(color)}
            />
          </Tooltip>
        )
      })}

      <Tooltip title={t('iconPicker.customColor')}>
        <ColorPicker
          value={value}
          size="small"
          disabledAlpha
          onChangeComplete={(color) => onChange(color.toHexString())}
        />
      </Tooltip>
    </Flex>
  )
}
